import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import KuposModal from './KuposModal';
import SvgHome from './SvgHome';
import KuposInput from './KuposInput';
import KuposButton from './KuposButton';
import ApiUrls from '../../services/apiUrls';
import DateService from '../../services/dateService';

export class AddNewBipCard extends Component {
  static propTypes = {
    common: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    t: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      addingBipCard: false,
    };
  }

  onInputChange = (val, key) => {
    switch (key) {
      case 'cardName':
        this.setState({ cardName: val, cardNameError: null });
        break;
      case 'cardNumber':
        this.setState({ cardNumber: val, cardNumberError: null });
        break;
    }
  };

  onInputBlur = (text, inp) => {
    if (!text) {
      if (inp == 'cardNumber') {
        this.setState({
          cardNumberError: {
            message: 'VALIDATIONS.INSERT_BIP_CARD_NUMBER',
          },
        });
      } else if (inp == 'cardName') {
        this.setState({
          cardNameError: {
            message: 'VALIDATIONS.BIP_CARD_NAME',
          },
        });
      }
    }
  };

  validate = () => {
    if (!this.state.cardName) {
      this.setState({
        cardNameError: {
          message: 'VALIDATIONS.BIP_CARD_NAME',
        },
      });
      return false;
    }
    if (!this.state.cardNumber) {
      this.setState({
        cardNumberError: {
          message: 'VALIDATIONS.INSERT_BIP_CARD_NUMBER',
        },
      });
      return false;
    }

    return true;
  };

  addCard = () => {
    if (!this.validate()) {
      return;
    }

    this.setState({ addingBipCard: true });

    console.log('All good and props are', this.props);

    let addCardTime = `${DateService.getCurrentHour()}.${DateService.getCurrentMinute()}`;

    let data = {
      user_id: this.props.data.loginData.id,
      user_name: this.props.data.loginData.name,
      user_image: this.props.data.loginData.image_link,
      contact_no: this.props.data.loginData.phone,
      email: this.props.data.loginData.email,
      status: 'ACTIVE',
      card_name: this.state.cardName,
      card_number: this.state.cardNumber,
      verification_status: 'NOT_VERIFIED',
      remarks: 'Test Remark',
      add_time_milli_secs: DateService.getUTC(),
      add_date_stg: DateService.getTodayString(),
      add_time_stg: addCardTime,
    };

    console.log('Data is ', data);

    this.props.actions.addBipCard({ url: ApiUrls.addBipCard(), data: data }).then(
      res => {
        this.onResponse(res);
      },
      res => {
        this.onResponse(res);
      },
    );
  };

  onResponse = result => {
    this.setState({ addingBipCard: false, cardName: null, cardNumber: null });
    this.props.onAddCard(result);

    // if(result && result.data && result.data.success && result.data.data){
    //   this.props.onAddCard()
    // }
    // console.log('Result from add card is', result);
  };

  render() {
    return (
      <div className="common-add-new-bip-card">
        <KuposModal
          showModal={this.props.showModal}
          onHide={this.props.onHide}
          size="md"
          ariaLabel="login-modal"
        >
          <div className="login-signup-block delete-bip-card add-bip-card">
            <div className="close-button pointer" onClick={this.props.onHide}>
              <SvgHome name="close" />
            </div>
            <div className="main-bip-add-parent-container">
              <div className="bold-text font12 bip-pop-up-title">
                {this.props.t('PROFILE.ADD_BIP_HEADING')}
              </div>
              <div className="add-bip-card-main-image">
                <img src="/static/images/example_bip_card.png" />
              </div>
              <div className="add-bip-card-input-container">
                <div className="add-bip-card-input-container-inner">
                  <div className="bip-input-add-container">
                    <div className="recarge-input-label font10 bold-text">
                      {this.props.t('PROFILE.NAME')}
                    </div>

                    <KuposInput
                      placeholder={this.props.t('PROFILE.NAME_ENTER_PLACEHOLDER')}
                      className="kupos-border font10 bip-recharge-input add-bip-input"
                      value={this.state.cardName}
                      onBlur={val => this.onInputBlur(val, 'cardName')}
                      onChange={val => this.onInputChange(val, 'cardName')}
                      error={this.state.cardNameError ? true : false}
                      errorMessage={
                        this.state.cardNameError ? this.state.cardNameError.message : ''
                      }
                    />
                  </div>

                  <div className="bip-input-add-container">
                    <div className="recarge-input-label font10 bold-text">
                      {this.props.t('PROFILE.CARD_NUMBER')}
                    </div>

                    <KuposInput
                      placeholder="XXXXXXXX"
                      className="kupos-border font10 bip-recharge-input add-bip-input"
                      value={this.state.cardNumber}
                      onBlur={val => this.onInputBlur(val, 'cardNumber')}
                      onChange={val => this.onInputChange(val, 'cardNumber')}
                      error={this.state.cardNumberError ? true : false}
                      errorMessage={
                        this.state.cardNumberError ? this.state.cardNumberError.message : ''
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="bip-popup-button-container">
                <button
                  onClick={this.addCard}
                  className="pay-now-button kupos-button"
                  disabled={this.state.addingBipCard ? true : false}
                >
                  {this.state.addingBipCard ? (
                    <div className="loader-cricle"></div>
                  ) : (
                    <span>{this.props.t('PROFILE.ADD_BIP_CARD_BUTTON')}</span>
                  )}
                </button>
                {/* <KuposButton onClick={this.addCard} className="bip-popup-button1 font12">
                  {this.props.t('PROFILE.ADD_BIP_CARD_BUTTON')}
                </KuposButton> */}
              </div>
            </div>
          </div>
        </KuposModal>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AddNewBipCard);



// WEBPACK FOOTER //
// ./src/features/common/AddNewBipCard.js